"use client"
import {
  Accordion,
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  AccordionSummaryProps,
  styled,
  Typography,
} from "@mui/material"
import React, { useState } from "react"
import { colors, sizes } from "../../theme/theme"

const StyledAccordion = styled(Accordion)<AccordionProps>`
  width: 100%;
  &.MuiPaper-root {
    padding: ${sizes.baseTriple} 20px;
    color: ${colors.black};
    background-color: ${colors.white};
    box-shadow: 9.772px -9.772px 36.646px 0px rgba(15, 36, 79, 0.08);
    border-radius: 20px;
    border: solid 1px transparent;
    &:before {
      display: none; // Removes the default
    }
    &.Mui-expanded {
      border: solid 1px ${colors.red};
      margin: 0;
    }
  }
`

const StyledAccordionSummary = styled(AccordionSummary)<AccordionSummaryProps>`
  padding: 0;
  min-height: unset;
  width: 100%;
  gap: ${sizes.baseDouble};
  &.MuiAccordionSummary-root {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0;
    min-height: unset;
    gap: ${sizes.baseDouble};
    & .MuiAccordionSummary-content {
      gap: ${sizes.baseDouble};
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align: start;
      margin: 0;
      width: 100%;
    }
  }
`

const RedTitleStyled = styled(Typography)`
  color: ${colors.red};
` as typeof Typography

const StyledAccordionDetails = styled(AccordionDetails)<AccordionSummaryProps>`
  font-size: 16px;
  color: ${colors.black};
  margin-top: 15px;
  text-align: start;
  padding-inline-start: 0;
`

interface AccordionItemProps {
  title: string
  pretitle?: string
  text: string
  openIcon: React.ReactNode
  closeIcon: React.ReactNode
  className?: string // Add this line
  onClick?: () => void
}

const AccordionItem: React.FC<React.PropsWithChildren<AccordionItemProps>> = ({
  title,
  pretitle,
  text,
  openIcon,
  closeIcon,
  className, // Add this line
  onClick,
}) => {
  const [expanded, setExpanded] = useState(false)

  const handleChange = () => {
    setExpanded(!expanded)
  }

  return (
    <StyledAccordion
      expanded={expanded}
      onChange={handleChange}
      className={className} // Add this line
      slotProps={{ heading: { component: "div" } }}
      onClick={onClick}
    >
      <StyledAccordionSummary
        expandIcon={expanded ? closeIcon : openIcon}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        {pretitle && (
          <RedTitleStyled variant="h5" component="p">
            {pretitle}
          </RedTitleStyled>
        )}
        <Typography variant="h5" component="h3">
          {title}
        </Typography>
      </StyledAccordionSummary>
      <StyledAccordionDetails>
        <Typography variant={"body2"}>{text}</Typography>
      </StyledAccordionDetails>
    </StyledAccordion>
  )
}

export default AccordionItem
